/**
 * 根据 IP 国家返回默认语言（用于 locale 为 default 时的选中）
 * - 巴西 (BR) → 葡语 (pt)
 * - 越南 (VN) → 越南语 (vi)
 * - 中东 (AE/SA) → 阿拉伯语 (ar)
 * - 其他 → 英文 (en)
 */
import { getOrigin } from "utils/method";
import { Request } from "@xt/xtbase";

const IP_API_URL = getOrigin("www") + "/sapi/v4/ip/public/info/ip";

/** 巴西 → 葡语 */
const BR_LOCALE = "pt";
/** 越南 → 越南语 */
const VI_LOCALE = "vi";
/** 中东 → 阿拉伯语 */
const ARABIC_COUNTRY_CODES = ["AE", "SA"];
/** 其他 → 英文 */
const DEFAULT_LOCALE = "en";

/**
 * 根据国家代码返回 locale
 * @param {string|null|undefined} countryCode 如 "AE", "BR", "SA", "VN"
 * @returns {"pt"|"vi"|"ar"|"en"}
 */
export function getLocaleByCountryCode(countryCode) {
  if (!countryCode) return DEFAULT_LOCALE;
  const code = countryCode.toUpperCase();
  if (code === "BR") return BR_LOCALE;
  if (code === "VN") return VI_LOCALE;
  if (ARABIC_COUNTRY_CODES.includes(code)) return "ar";
  return DEFAULT_LOCALE;
}

/**
 * 通过 IP 获取国家代码（与 ssr-web-index fiatMarket 一致）
 * @returns {Promise<string|null>} 如 "AE", "BR", "SA", "VN"
 */
export async function getCountryCodeByIP() {
  try {
    const response = await Request.XtAxios4.get(IP_API_URL);
    const countryCode = response?.countryCode || response?.data?.countryCode;
    return countryCode ? countryCode.toUpperCase() : null;
  } catch (error) {
    console.warn("getDefaultLocaleByIP: getCountryCodeByIP failed", error);
    return null;
  }
}

/**
 * 根据当前请求 IP 获取应使用的默认 locale
 * @returns {Promise<string>} "pt" | "vi" | "ar" | "en"
 */
export async function getDefaultLocaleByIP() {
  try {
    const countryCode = await getCountryCodeByIP();
    return getLocaleByCountryCode(countryCode);
  } catch (e) {
    return DEFAULT_LOCALE;
  }
}
